import React from 'react'
import { Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from '@tanstack/react-query'
import { Loan } from '../types/Loan'
import RepaymentSchedule from './LoanRepaymentScedule'
import loanQueryKeys from '../queries/loanQueryKeys'

interface LoanRepaymentScheduleProps {
  loan: Loan | null
  handleOk: () => void
  isLocked?: boolean
}

const LoanRepaymentSceduleModal: React.FC<LoanRepaymentScheduleProps> = ({
  loan,
  handleOk,
  isLocked = false
}: LoanRepaymentScheduleProps) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  const hasSavedRef = React.useRef(false)

  const handleClose = () => {
    if (hasSavedRef.current) {
      queryClient.invalidateQueries({ queryKey: loanQueryKeys.summaries() })
      hasSavedRef.current = false
    }
    handleOk()
  }

  const handleDataChanged = () => {
    hasSavedRef.current = true
  }

  return (
    <Modal
      style={{ maxWidth: '1200px' }}
      title={t('loans:repayment-schedule')}
      open={!!loan}
      onOk={handleClose}
      onCancel={handleClose}
      cancelButtonProps={{ style: { display: 'none' } }}
      maskClosable={false}
      width="unset"
    >
      {loan && <RepaymentSchedule loanData={loan} isLocked={isLocked} onDataChanged={handleDataChanged} />}
    </Modal>
  )
}

export default LoanRepaymentSceduleModal
